import { useEffect, useState } from "react";
import { getBookedAuditionees } from "../../../../CastingBotFirebase";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCircleXmark } from "@fortawesome/free-solid-svg-icons";

function ViewAuditioneesTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;

  const header = ['Name', 'Email', 'Phone', 'Recalled?']
  const [auditionees, setAuditionees] = useState(null);
  var body = [];

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(castingData.slots, userData.active_organisation_id, setAuditionees)
    // eslint-disable-next-line
  }, []);

  if(auditionees === null) return <SectionLoader />

  body = _parseToTable(auditionees, castingData.slots);

  if(body.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        <SubTabTable header={header} body={body} numbered />
      </SubTabParent>
    )
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Bookings' 
        description="Auditionee details will appear here"
      />
    )
  }

}

export default ViewAuditioneesTab;



const _parseToTable = (auditionees, slots) => {

  auditionees.sort((a,b) => {return a.name > b.name? 1 : -1})

  let auditioneesArray = auditionees.map((auditionee) => {
    var slot = null;
    slots.forEach((s) => {if(s.auditionee_id === auditionee.uid) slot = s;});
    const verdictColour = _getVerdictColour(slot.notes.audition_verdict);

    return [
      (<div style={{color: verdictColour}}>{auditionee.name}</div>),
      (<div style={{color: verdictColour}}>{auditionee.email}</div>),
      (<div style={{color: verdictColour}}>{auditionee.phone}</div>),
      (slot.recalled? <FontAwesomeIcon style={{color: '#2ecc71'}} icon={faCheckCircle}/> : <FontAwesomeIcon style={{color: '#e74c3c'}} icon={faCircleXmark} />)
    ];
  })

  console.log(auditioneesArray);

  return auditioneesArray;
}

const _getVerdictColour = (verdict) => {
  if      (verdict === 'undetermined')    return '#cccccc'; // Light grey
  else if (verdict === 'poor')            return '#e74c3c'; // Red
  else if (verdict === 'ok')              return '#e67e22'; // Orange
  else if (verdict === 'good')            return '#f1c40f'; // Yellow
  else                                    return '#2ecc71'; // Green
}